import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Layout,
  Drawer,
  Button,
  Tooltip,
  Input,
  Typography,
} from "antd";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  FileTextOutlined,
  CheckSquareOutlined,
  CloseOutlined,
  SearchOutlined,
  UserOutlined,
  ReadOutlined,
  CalendarOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

import { motion } from "framer-motion";

import {
  Box,
  Grid,
  Avatar,
} from "@mui/material";

import {
  FaGraduationCap,
} from "react-icons/fa";

import AssignmentView from "../pages/Teachers/AssignmentView";
import StudentOverview from "./StudentOverview";

import ParentAndStudentProfile from "./ParentAndStudentProfile";

import TransActionPerStudent from "../SchoolDashApp/DailyTransaction/TransActionPerStudent";

import UserSearchBox from "../SchoolDashApp/UserDetails/UserSearchBox";
import ProfileImage from "../NewDashboard/ProfileImage";

import PostTodoList from "../NewDashboard/CalenderAndTodo/PostTodoList";
import Darkmode from "../NewDashboard/Darkmode/Darkmode";

import NotificationIcon from "../components/ChatApp/NotificationIcon";
import Notice from "../components/ChatApp/Notice";

import ViewPlanCoursesList from "./PlanCourses/ViewPlanCoursesList";
import PlanCoursesPage from "./PlanCourses/PlanCoursesPage";
import MyLearningCoursesEnvironment from "./PlanCourses/MyLearningCoursesEnvironment";

import ParentsStudentGrades from "../pages/Students/ParentsStudentGrades";

import api from "../api/api";

import defaultAvatar from "./maleee.jpg";
import logo from "./tradeschoollogo.jpg";
import dashboardBanner from "./teacherss.jpg";

const {
  Header,
  Sider,
  Content,
} = Layout;

const {
  Typography: AntTypography,
} = Typography;

const COLORS = {
  primary: "#3B4B8A",
  primaryDark: "#2E3A70",
  secondary: "#167A89",

  page: "#F5F7FB",
  pureWhite: "#FFFFFF",

  text: "#17233C",
  muted: "#667085",
  border: "#E1E6EF",
  soft: "#F8FAFD",

  success: "#16805C",
  warning: "#C88719",
  error: "#C44545",
  info: "#3B82A6",

  sidebar: "#101827",
  sidebarAlt: "#162033",
  sidebarBorder: "#26344C",

  sidebarText: "#DCE5F2",
  sidebarMuted: "#91A0B5",
  sidebarIcon: "#91A9C7",
  sidebarBright: "#7C9CFF",

  gold: "#C88719",
  yellow: "#D49A27",
  orange: "#C97B18",
  green: "#16805C",
  sky: "#3B82A6",
  antique: "#8795A8",

  black: "#101827",
  white: "#F4F7FB",
  gray: "#AAB6C6",

  shadow:
    "0 12px 35px rgba(23,35,60,.08)",
};

const baseMenuItems = [
  {
    key: "overview",
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },

  {
    key: "plancoursespage",
    icon: <FileTextOutlined />,
    label: "Plan Courses",
  },

  {
    key: "mycoursedetails",
    icon: <FileTextOutlined />,
    label: "My Course Details",
  },

  {
    key: "mylearning",
    icon: <ReadOutlined />,
    label: "My Learning",
  },

  {
    key: "studentsassignments",
    icon: <CheckSquareOutlined />,
    label: "Assignments",
  },
];

const StudentDashboard = () => {
  const [collapsed, setCollapsed] =
    useState(false);

  const [drawerOpen, setDrawerOpen] =
    useState(false);

  const [darkMode, setDarkMode] =
    useState(false);

  const [activePage, setActivePage] =
    useState("overview");

  const [selectedUser, setSelectedUser] =
    useState(null);

  const [selectedChild, setSelectedChild] =
    useState(null);

  const [menuSearch, setMenuSearch] =
    useState("");

  const [todoOpen, setTodoOpen] =
    useState(false);

  const [isMobile, setIsMobile] =
    useState(
      typeof window !== "undefined"
        ? window.innerWidth < 900
        : false
    );

  const [isNavigating, setIsNavigating] =
    useState(false);

  const [pendingPage, setPendingPage] =
    useState(null);

  const [showPayments, setShowPayments] =
    useState(false);

  const [showGrades, setShowGrades] =
    useState(false);

  const [user, setUser] =
    useState(null);

  const [children, setChildren] =
    useState([]);

  const [loadingUser, setLoadingUser] =
    useState(true);

  const [loadingChildren, setLoadingChildren] =
    useState(true);

  const [tempImage, setTempImage] =
    useState(null);

  const [loadingLogout, setLoadingLogout] =
    useState(false);

  const token =
    localStorage.getItem("access");

  useEffect(() => {
    const handleResize = () => {
      const mobile =
        window.innerWidth < 900;

      setIsMobile(mobile);

      if (mobile) {
        setCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  useEffect(() => {
    const style =
      document.createElement("style");

    style.id =
      "cayep-student-dashboard-styles";

    style.innerHTML = `
      * {
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        margin: 0;
        min-height: 100%;
      }

      body {
        overflow: hidden;
        background: #F5F7FB;
        color: #17233C;
      }

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: #A8B5C8;
        border-radius: 20px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #3B4B8A;
      }

      * {
        scrollbar-width: thin;
        scrollbar-color:
          #A8B5C8
          transparent;
      }

      .student-menu-button {
        width: 39px !important;
        height: 39px !important;
        min-width: 39px !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 9px !important;
        border: 1px solid #E1E6EF !important;
        background: #FFFFFF !important;
        color: #43516B !important;
        box-shadow: none !important;
      }

      .student-menu-button:hover {
        color: #3B4B8A !important;
        border-color: #B9C4DE !important;
        background: #F0F3FA !important;
      }

      .student-dark .student-menu-button {
        background: #182236 !important;
        border-color: #2B3951 !important;
        color: #DCE5F2 !important;
      }

      .student-search-box
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 9px !important;
        border: 1px solid #E1E6EF !important;
        background: #FFFFFF !important;
        box-shadow: none !important;
      }

      .student-search-box
      .ant-input-affix-wrapper:hover {
        border-color: #B9C4DE !important;
      }

      .student-search-box
      .ant-input-affix-wrapper-focused {
        border-color: #3B4B8A !important;
        box-shadow:
          0 0 0 2px rgba(59,75,138,.10) !important;
      }

      .student-search-box
      .ant-input {
        color: #17233C !important;
      }

      .student-search-box
      .ant-input::placeholder {
        color: #8793A5 !important;
      }

      .student-dark
      .student-search-box
      .ant-input-affix-wrapper {
        background: #182236 !important;
        border-color: #2B3951 !important;
      }

      .student-dark
      .student-search-box
      .ant-input {
        color: #F4F7FB !important;
      }

      .student-sidebar-search
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 8px !important;
        background: #172236 !important;
        border: 1px solid #2A3951 !important;
        box-shadow: none !important;
      }

      .student-sidebar-search
      .ant-input-affix-wrapper:hover {
        border-color: #4D6194 !important;
      }

      .student-sidebar-search
      .ant-input {
        background: transparent !important;
        color: #E7EDF6 !important;
      }

      .student-sidebar-search
      .ant-input::placeholder {
        color: #8190A6 !important;
      }

      .student-sidebar-search
      .ant-input-affix-wrapper-focused {
        border-color: #3B4B8A !important;
        box-shadow:
          0 0 0 2px rgba(59,75,138,.18) !important;
      }

      .student-sidebar-scroll {
        scrollbar-width: thin;
        scrollbar-color:
          #33435C
          transparent;
      }

      .student-section-title {
        padding:
          16px 18px 7px;
        color: #8190A6;
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 1.25px;
        user-select: none;
      }

      .student-nav-item {
        position: relative;
        width: calc(100% - 24px);
        min-height: 43px;
        margin: 2px 12px;
        padding: 0 12px;
        border: 0;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 11px;
        color: #C9D5E5;
        background: transparent;
        cursor: pointer;
        text-align: left;
        font-family: inherit;
        font-size: 13px;
        font-weight: 500;
        transition:
          background 150ms ease,
          color 150ms ease,
          transform 150ms ease;
      }

      .student-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.34),
            rgba(59,75,138,.12)
          );
        color: #FFFFFF;
      }

      .student-nav-item:hover
      .student-nav-icon {
        color: #8FA8FF;
        border-color:
          rgba(143,168,255,.20);
        background:
          rgba(143,168,255,.08);
      }

      .student-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.66),
            rgba(22,122,137,.24)
          );
        color: #FFFFFF;
        font-weight: 700;
        box-shadow:
          0 6px 18px rgba(0,0,0,.18);
      }

      .student-nav-item.active::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 0 3px 3px 0;
        background: #8FA8FF;
        box-shadow:
          0 0 10px rgba(143,168,255,.55);
      }

      .student-nav-item.active
      .student-nav-icon {
        color: #A6B9FF;
        border-color:
          rgba(166,185,255,.25);
        background:
          rgba(166,185,255,.10);
      }

      .student-nav-icon {
        width: 28px;
        height: 28px;
        min-width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
        color: #91A9C7;
        border: 1px solid transparent;
        font-size: 15px;
        transition: all 150ms ease;
      }

      .student-nav-label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 1.2;
      }

      .student-nav-chevron {
        margin-left: auto;
        opacity: 0;
        transform: translateX(-3px);
        transition: all 150ms ease;
        color: #9EB1FF;
      }

      .student-nav-item:hover
      .student-nav-chevron,
      .student-nav-item.active
      .student-nav-chevron {
        opacity: 1;
        transform: translateX(0);
      }

      .student-collapsed-item {
        width: calc(100% - 18px);
        justify-content: center;
        margin-left: 9px;
        margin-right: 9px;
        padding: 0;
      }

      .student-collapsed-item
      .student-nav-chevron {
        display: none;
      }

      .student-collapsed-item
      .student-nav-label {
        display: none;
      }

      .student-collapsed-item
      .student-nav-icon {
        width: 34px;
        height: 34px;
        min-width: 34px;
      }

      .student-header-action {
        width: 39px;
        height: 39px;
        min-width: 39px;
        padding: 0;
        border-radius: 9px;
        border: 1px solid #E1E6EF;
        background: #FFFFFF;
        color: #43516B;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 160ms ease;
      }

      .student-header-action:hover {
        color: #3B4B8A;
        border-color: #B9C4DE;
        background: #F0F3FA;
      }

      .student-dark
      .student-header-action {
        background: #182236;
        border-color: #2B3951;
        color: #DCE5F2;
      }

      .student-profile-container {
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #3B4B8A;
        background: #FFFFFF;
        box-shadow:
          0 3px 12px rgba(23,35,60,.14);
        position: relative;
      }

      .student-profile-avatar {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 50%;
      }

      .student-profile-container > *,
      .student-profile-avatar > * {
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .student-profile-container img,
      .student-profile-avatar img {
        width: 100% !important;
        height: 100% !important;
        min-width: 100% !important;
        min-height: 100% !important;
        object-fit: cover !important;
        object-position: center !important;
        display: block !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .student-workspace {
        border: 1px solid #E1E6EF;
        background: #FFFFFF;
        border-radius: 11px;
        min-height: calc(100vh - 111px);
        box-shadow:
          0 4px 18px rgba(23,35,60,.035);
      }

      .student-workspace-dark {
        background: #182236;
        border-color: #2B3951;
      }

      .student-navigation-progress {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        z-index: 1000;
        overflow: hidden;
        background: rgba(59,75,138,.12);
      }

      .student-navigation-progress::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background:
          linear-gradient(
            90deg,
            #3B4B8A,
            #167A89
          );
        box-shadow:
          0 0 8px rgba(59,75,138,.45);
        animation:
          studentNavigationProgress
          3s linear forwards;
      }

      @keyframes studentNavigationProgress {
        0% { width: 0%; }
        15% { width: 22%; }
        45% { width: 48%; }
        70% { width: 70%; }
        90% { width: 88%; }
        100% { width: 100%; }
      }

      .student-loading-label {
        position: absolute;
        top: 11px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1001;
        padding: 5px 10px;
        border-radius: 6px;
        background: rgba(16,24,39,.96);
        color: #FFFFFF;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: .75px;
        text-transform: uppercase;
        white-space: nowrap;
        box-shadow:
          0 5px 15px rgba(0,0,0,.18);
      }

      .student-page-heading {
        min-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 8px;
        padding: 0 2px;
      }

      .student-page-heading-left {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .student-page-heading-line {
        width: 4px;
        height: 18px;
        min-width: 4px;
        border-radius: 3px;
        background:
          linear-gradient(
            180deg,
            #3B4B8A,
            #167A89
          );
        box-shadow:
          0 0 7px rgba(59,75,138,.22);
      }

      .student-page-heading-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #17233C;
        font-size: 14px;
        font-weight: 750;
      }

      .student-dark
      .student-page-heading-title {
        color: #F3F6FA;
      }

      .student-page-heading-meta {
        color: #667085;
        font-size: 10px;
        font-weight: 600;
        white-space: nowrap;
        letter-spacing: .2px;
      }

      .student-dark
      .student-page-heading-meta {
        color: #9BA9BC;
      }

      .student-dark {
        color: #F3F6FA;
      }

      .student-dark
      .student-sidebar-search
      .ant-input-affix-wrapper {
        background: #172236 !important;
        border-color: #2B3951 !important;
      }

      .student-dark
      .student-sidebar-search
      .ant-input {
        color: #F3F6FA !important;
      }

      .student-dark
      .student-sidebar-search
      .ant-input::placeholder {
        color: #8190A6 !important;
      }

      .student-dark
      .student-nav-item {
        color: #C9D5E5;
      }

      .student-dark
      .student-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.38),
            rgba(22,122,137,.13)
          );
        color: #FFFFFF;
      }

      .student-dark
      .student-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.68),
            rgba(22,122,137,.28)
          );
        color: #FFFFFF;
      }

      .student-dark
      .student-section-title {
        color: #8190A6;
      }

      .student-dark
      .student-page-heading-line {
        background:
          linear-gradient(
            180deg,
            #8FA8FF,
            #54B8C4
          );
      }

      .student-sidebar-shell {
        position: relative;
        overflow: hidden;
        background:
          linear-gradient(
            145deg,
            #101827 0%,
            #121D2E 45%,
            #101827 100%
          );
      }

      .student-sidebar-shell::before {
        content: "";
        position: absolute;
        inset: -40%;
        pointer-events: none;
        background:
          repeating-linear-gradient(
            118deg,
            transparent 0,
            transparent 72px,
            rgba(124,156,255,.045) 73px,
            rgba(124,156,255,.045) 75px,
            transparent 76px,
            transparent 145px
          );
        animation:
          studentSidebarStripes
          24s linear infinite;
      }

      .student-sidebar-shell::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        pointer-events: none;
        background:
          linear-gradient(
            180deg,
            rgba(143,168,255,.10),
            rgba(143,168,255,.42),
            rgba(84,184,196,.08)
          );
        box-shadow:
          0 0 18px rgba(124,156,255,.10);
      }

      .student-sidebar-content {
        position: relative;
        z-index: 2;
        height: 100%;
      }

      @keyframes studentSidebarStripes {
        0% {
          transform:
            translate3d(-45px,-20px,0)
            rotate(0deg);
        }

        50% {
          transform:
            translate3d(45px,20px,0)
            rotate(1deg);
        }

        100% {
          transform:
            translate3d(-45px,-20px,0)
            rotate(0deg);
        }
      }

      .student-child-count {
        margin-left: auto;
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(124,156,255,.14);
        color: #A6B9FF;
        font-size: 9px;
        font-weight: 800;
      }

      .student-child-empty {
        margin: 8px 12px;
        padding: 12px;
        border: 1px dashed #2A3951;
        border-radius: 8px;
        color: #8190A6;
        font-size: 10px;
        text-align: center;
      }

      .student-child-item {
        min-height: 40px;
      }

      .student-child-avatar {
        width: 27px;
        height: 27px;
        min-width: 27px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid rgba(143,168,255,.28);
        background: #172236;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .student-child-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      @media (prefers-reduced-motion: reduce) {
        .student-sidebar-shell::before {
          animation: none;
        }
      }

      @media (max-width: 899px) {
        .student-profile-container {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .student-workspace {
          min-height: calc(100vh - 96px);
          border-radius: 8px;
        }

        .student-page-heading {
          min-height: 30px;
        }

        .student-page-heading-title {
          font-size: 13px;
        }

        .student-page-heading-meta {
          display: none;
        }
      }

      @media (max-width: 560px) {
        .student-header-action {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .student-menu-button {
          width: 36px !important;
          height: 36px !important;
          min-width: 36px !important;
        }

        .student-profile-container {
          width: 34px;
          height: 34px;
          min-width: 34px;
        }

        .student-workspace {
          border-left: 0;
          border-right: 0;
          box-shadow: none;
        }
      }
    `;

    document.head.appendChild(style);

    return () => {
      const existing =
        document.getElementById(
          "cayep-student-dashboard-styles"
        );

      if (existing) {
        existing.remove();
      }
    };
  }, []);

  const theme = useMemo(
    () => ({
      darkMode,

      background: darkMode
        ? "#0D1522"
        : COLORS.page,

      sidebar: COLORS.sidebar,

      header: darkMode
        ? "#121D2E"
        : COLORS.pureWhite,

      card: darkMode
        ? "#182236"
        : COLORS.pureWhite,

      inputBackground: darkMode
        ? "#182236"
        : COLORS.pureWhite,

      text: darkMode
        ? "#F3F6FA"
        : COLORS.text,

      secondary: darkMode
        ? "#9BA9BC"
        : COLORS.muted,

      border: darkMode
        ? "#2B3951"
        : COLORS.border,

      primary: COLORS.primary,
      navy: COLORS.sidebar,
      blue: COLORS.secondary,
      gold: COLORS.gold,
      yellow: COLORS.yellow,
      orange: COLORS.orange,
      green: COLORS.green,
      sky: COLORS.sky,
      antique: COLORS.antique,
    }),
    [darkMode]
  );

  /*
   * ============================================================
   * FETCH USER PROFILE
   * ============================================================
   */

  const fetchUserProfile =
    async () => {
      if (!token) {
        setLoadingUser(false);
        return;
      }

      try {
        const response =
          await api.get(
            "/user-profile/",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`,
              },
            }
          );

        setUser(
          response.data
        );
      } catch (error) {
        console.error(
          "Student profile error:",
          error
        );
      } finally {
        setLoadingUser(false);
      }
    };

  /*
   * ============================================================
   * REFRESH USER
   * ============================================================
   */

  const refreshUser =
    async () => {
      if (!token) {
        return;
      }

      try {
        const response =
          await api.get(
            "/user-profile/",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`,
              },
            }
          );

        setUser(
          response.data
        );

        setTempImage(null);
      } catch (error) {
        console.error(
          "Refresh profile error:",
          error
        );
      }
    };

  /*
   * ============================================================
   * FETCH LINKED STUDENTS
   * ============================================================
   */

  const fetchChildren =
    async () => {
      if (!token) {
        setLoadingChildren(false);
        return;
      }

      try {
        const response =
          await api.get(
            "/admissions/my-linked-students/",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`,
              },
            }
          );

        const data =
          response.data;

        let childrenData = [];

        if (Array.isArray(data)) {
          childrenData = data;
        } else if (
          Array.isArray(data?.results)
        ) {
          childrenData =
            data.results;
        } else if (
          Array.isArray(data?.data)
        ) {
          childrenData =
            data.data;
        } else if (
          Array.isArray(data?.students)
        ) {
          childrenData =
            data.students;
        }

        setChildren(
          childrenData
        );
      } catch (error) {
        console.error(
          "Linked students error:",
          error
        );

        setChildren([]);
      } finally {
        setLoadingChildren(false);
      }
    };

  useEffect(() => {
    fetchUserProfile();
    fetchChildren();
  }, []);

  /*
   * ============================================================
   * LOGOUT
   * ============================================================
   */

  const handleLogout =
    async () => {
      if (loadingLogout) {
        return;
      }

      setLoadingLogout(true);

      try {
        await api.post(
          "api/logout/",
          {}
        );
      } catch (error) {
        console.error(
          "Logout error:",
          error
        );
      } finally {
        localStorage.removeItem(
          "access"
        );

        localStorage.removeItem(
          "refresh"
        );

        setLoadingLogout(false);

        window.location.href =
          "/login";
      }
    };

  /*
   * ============================================================
   * CHILD MENU ITEMS
   * ============================================================
   */

  const childMenuItems =
    useMemo(
      () =>
        children.map(
          (child) => ({
            key:
              `child_${child.id}`,

            icon: (
              <span className="student-child-avatar">
                <img
                  src={
                    child.student_admission_image ||
                    defaultAvatar
                  }
                  alt={
                    child.full_name ||
                    "Student"
                  }
                />
              </span>
            ),

            label:
              child.full_name ||
              "Unnamed Student",

            child,
          })
        ),
      [children]
    );

  /*
   * ============================================================
   * MY STUDENTS GROUP
   * ============================================================
   */

  const myStudentsGroup =
    {
      key: "my-students",
      title: "BIO DATA",
      type: "group",
      children:
        childMenuItems,
    };

  /*
   * ============================================================
   * MENU LOOKUP
   * ============================================================
   */

  const menuLookup =
    useMemo(
      () => {
        const lookup = {};

        baseMenuItems.forEach(
          (item) => {
            lookup[item.key] =
              item;
          }
        );

        childMenuItems.forEach(
          (item) => {
            lookup[item.key] =
              item;
          }
        );

        return lookup;
      },
      [childMenuItems]
    );

  /*
   * ============================================================
   * SEARCH FILTER
   * ============================================================
   */

  const filteredBaseItems =
    useMemo(() => {
      const query =
        menuSearch
          .trim()
          .toLowerCase();

      if (!query) {
        return baseMenuItems;
      }

      return baseMenuItems.filter(
        (item) =>
          item.label
            .toLowerCase()
            .includes(query)
      );
    }, [menuSearch]);

  const filteredChildItems =
    useMemo(() => {
      const query =
        menuSearch
          .trim()
          .toLowerCase();

      if (!query) {
        return childMenuItems;
      }

      return childMenuItems.filter(
        (item) =>
          item.label
            .toLowerCase()
            .includes(query)
      );
    }, [
      menuSearch,
      childMenuItems,
    ]);

  /*
   * ============================================================
   * ACTIVE TITLE
   * ============================================================
   */

  const activeTitle =
    selectedUser
      ? "User Details"
      : activePage.startsWith(
          "child_"
        )
      ? selectedChild?.full_name ||
        "Student Profile"
      : menuLookup[
          activePage
        ]?.label ||
        "Dashboard";

  /*
   * ============================================================
   * STUDENT SELECTION
   * ============================================================
   */

  const selectChild =
    (child) => {
      setSelectedChild(
        child || null
      );

      setSelectedUser(null);

      setShowGrades(false);
      setShowPayments(false);

      setPendingPage(null);
      setIsNavigating(false);

      setActivePage(
        `child_${child.id}`
      );

      setMenuSearch("");

      if (isMobile) {
        setDrawerOpen(false);
      }
    };

  /*
   * ============================================================
   * NAVIGATION
   * ============================================================
   */

  const handleNavigation =
    (key) => {
      if (isNavigating) {
        return;
      }

      if (
        key.startsWith(
          "child_"
        )
      ) {
        const id =
          key.split("_")[1];

        const child =
          children.find(
            (item) =>
              String(item.id) ===
              String(id)
          );

        if (child) {
          selectChild(child);
        }

        return;
      }

      if (
        key === activePage &&
        !selectedUser &&
        !selectedChild
      ) {
        if (isMobile) {
          setDrawerOpen(false);
        }

        return;
      }

      setPendingPage(key);
      setIsNavigating(true);

      setSelectedUser(null);
      setSelectedChild(null);

      setShowGrades(false);
      setShowPayments(false);

      setMenuSearch("");

      if (isMobile) {
        setDrawerOpen(false);
      }

      window.setTimeout(() => {
        setActivePage(key);
        setPendingPage(null);
        setIsNavigating(false);
      }, 700);
    };

  /*
   * ============================================================
   * USER SEARCH SELECTION
   * ============================================================
   */

  const handleUserSelection =
    (value) => {
      setSelectedUser(value);
      setSelectedChild(null);
      setShowGrades(false);
      setShowPayments(false);
      setMenuSearch("");

      if (isMobile) {
        setDrawerOpen(false);
      }
    };

  /*
   * ============================================================
   * RENDER NORMAL PAGE
   * ============================================================
   */

  const renderNormalPage =
    () => {
      switch (activePage) {
        case "studentsassignments":
          return (
            <AssignmentView
              theme={theme}
            />
          );

        case "plancoursespage":
          return (
            <PlanCoursesPage
              theme={theme}
            />
          );

        case "mycoursedetails":
          return (
            <ViewPlanCoursesList
              theme={theme}
            />
          );

        case "mylearning":
          return (
            <MyLearningCoursesEnvironment
              theme={theme}
            />
          );

        case "overview":
        default:
          return (
            <Box
              sx={{
                display:
                  "flex",
                flexDirection:
                  "column",
                gap: 2.5,
              }}
            >


              <StudentOverview
                theme={theme}
              />
            </Box>
          );
      }
    };

  /*
   * ============================================================
   * STUDENT PROFILE PAGE
   * ============================================================
   */

  const renderStudentPage =
    () => {
      if (!selectedChild) {
        return (
          <Box
            sx={{
              p: 4,
              textAlign:
                "center",
              color:
                theme.secondary,
            }}
          >
            No student selected.
          </Box>
        );
      }

      return (
        <Box
          sx={{
            background:
              darkMode
                ? "linear-gradient(145deg,#111827,#1f2937)"
                : "linear-gradient(145deg,#ffffff,#f8fafc)",

            borderRadius: 3,

            p: {
              xs: 1.5,
              sm: 2.5,
              md: 3.5,
            },

            border:
              `1px solid ${theme.border}`,

            boxShadow:
              darkMode
                ? "0 20px 50px rgba(0,0,0,.35)"
                : "0 20px 50px rgba(15,23,42,.10)",

            position:
              "relative",

            overflow:
              "hidden",
          }}
        >
          <Box
            sx={{
              position:
                "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 5,
              background:
                "linear-gradient(90deg,#3B4B8A,#167A89,#C88719,#3B4B8A)",
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                md: "row",
              },
              gap: 3,
              alignItems:
                "center",
              mb: 3,
              pt: 1.5,
            }}
          >
            <Box
              sx={{
                position:
                  "relative",
              }}
            >
              <Avatar
                src={
                  selectedChild.student_admission_image ||
                  defaultAvatar
                }
                alt={
                  selectedChild.full_name ||
                  "Student"
                }
                sx={{
                  width: {
                    xs: 105,
                    sm: 125,
                    md: 140,
                  },

                  height: {
                    xs: 105,
                    sm: 125,
                    md: 140,
                  },

                  border:
                    `4px solid ${COLORS.primary}`,

                  boxShadow:
                    "0 12px 30px rgba(59,75,138,.25)",
                }}
              />

              <Box
                sx={{
                  position:
                    "absolute",
                  bottom: 5,
                  right: 5,
                  width: 17,
                  height: 17,
                  borderRadius:
                    "50%",
                  background:
                    "#22c55e",
                  border:
                    "3px solid #fff",
                }}
              />
            </Box>

            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                textAlign: {
                  xs: "center",
                  md: "left",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: 23,
                    sm: 28,
                    md: 31,
                  },

                  fontWeight: 900,

                  color:
                    theme.text,

                  lineHeight:
                    1.2,

                  wordBreak:
                    "break-word",
                }}
              >
                {
                  selectedChild.full_name
                }
              </Typography>

              <Typography
                sx={{
                  mt: 0.7,
                  fontSize: 13,
                  fontWeight: 600,
                  color:
                    theme.secondary,
                }}
              >
                Student Profile
              </Typography>

              <Box
                sx={{
                  display:
                    "flex",
                  flexWrap:
                    "wrap",
                  gap: 1,
                  mt: 1.8,
                  justifyContent: {
                    xs: "center",
                    md: "flex-start",
                  },
                }}
              >
                <Box
                  sx={{
                    px: 1.8,
                    py: 0.65,
                    borderRadius: 20,
                    background:
                      "linear-gradient(135deg,#111827,#374151)",
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 800,
                  }}
                >
                  {
                    selectedChild.grade_class_name ||
                    "N/A"
                  }
                </Box>

                <Box
                  sx={{
                    px: 1.8,
                    py: 0.65,
                    borderRadius: 20,
                    background:
                      "linear-gradient(135deg,#3B4B8A,#167A89)",
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 800,
                  }}
                >
                  Student ID:{" "}
                  {
                    selectedChild.id ||
                    "N/A"
                  }
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  display:
                    "flex",
                  gap: 1,
                  flexWrap:
                    "wrap",
                  justifyContent: {
                    xs: "center",
                    md: "flex-start",
                  },
                }}
              >
                <Button
                  onClick={() => {
                    setShowPayments(
                      false
                    );
                    setShowGrades(
                      true
                    );
                  }}
                  style={{
                    padding:
                      "8px 18px",
                    borderRadius: 8,
                    fontWeight: 800,
                    background:
                      "linear-gradient(135deg,#3B4B8A,#167A89)",
                    color: "#fff",
                    border: "none",
                  }}
                >
                  View Grades
                </Button>

                <Button
                  onClick={() => {
                    setShowGrades(
                      false
                    );
                    setShowPayments(
                      true
                    );
                  }}
                  style={{
                    padding:
                      "8px 18px",
                    borderRadius: 8,
                    fontWeight: 800,
                    background:
                      "linear-gradient(135deg,#C88719,#D49A27)",
                    color: "#fff",
                    border: "none",
                  }}
                >
                  Payment Transactions
                </Button>
              </Box>
            </Box>
          </Box>

          {showGrades ? (
            <Box>
              <Button
                onClick={() =>
                  setShowGrades(
                    false
                  )
                }
                style={{
                  marginBottom: 18,
                  borderRadius: 8,
                  fontWeight: 700,
                }}
              >
                ← Back to Student Overview
              </Button>

              <ParentsStudentGrades
                selectedChild={
                  selectedChild
                }
                onBack={() =>
                  setShowGrades(
                    false
                  )
                }
              />
            </Box>
          ) : showPayments ? (
            <Box
              sx={{
                background:
                  theme.card,
                borderRadius: 3,
                p: {
                  xs: 1.5,
                  md: 2.5,
                },
                border:
                  `1px solid ${theme.border}`,
              }}
            >
              <Button
                onClick={() =>
                  setShowPayments(
                    false
                  )
                }
                style={{
                  marginBottom: 18,
                  borderRadius: 8,
                  fontWeight: 700,
                }}
              >
                ← Back to Student Overview
              </Button>

              <TransActionPerStudent
                selectedChild={
                  selectedChild
                }
                onBack={() =>
                  setShowPayments(
                    false
                  )
                }
              />
            </Box>
          ) : (
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <Box
                  sx={{
                    p: 2.5,
                    height: "100%",
                    borderRadius: 3,
                    background:
                      darkMode
                        ? "linear-gradient(145deg,#1f2937,#111827)"
                        : "#ffffff",
                    border:
                      `1px solid ${theme.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: 17,
                      color:
                        theme.text,
                      mb: 2,
                    }}
                  >
                    Attendance Summary
                  </Typography>

                  <Grid
                    container
                    spacing={1}
                  >
                    <Grid
                      item
                      xs={4}
                    >
                      <Box
                        sx={{
                          textAlign:
                            "center",
                          p: 1.5,
                          borderRadius: 2,
                          background:
                            darkMode
                              ? "rgba(34,197,94,.12)"
                              : "#ecfdf5",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 10,
                            fontWeight: 700,
                            color:
                              "#22c55e",
                          }}
                        >
                          Present
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 23,
                            fontWeight: 900,
                            color:
                              "#22c55e",
                          }}
                        >
                          {
                            selectedChild.total_present ||
                            0
                          }
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={4}
                    >
                      <Box
                        sx={{
                          textAlign:
                            "center",
                          p: 1.5,
                          borderRadius: 2,
                          background:
                            darkMode
                              ? "rgba(239,68,68,.12)"
                              : "#fef2f2",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 10,
                            fontWeight: 700,
                            color:
                              "#ef4444",
                          }}
                        >
                          Absent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 23,
                            fontWeight: 900,
                            color:
                              "#ef4444",
                          }}
                        >
                          {
                            selectedChild.total_absent ||
                            0
                          }
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={4}
                    >
                      <Box
                        sx={{
                          textAlign:
                            "center",
                          p: 1.5,
                          borderRadius: 2,
                          background:
                            darkMode
                              ? "rgba(200,135,25,.12)"
                              : "#fff8e8",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 10,
                            fontWeight: 700,
                            color:
                              "#C88719",
                          }}
                        >
                          Late
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 23,
                            fontWeight: 900,
                            color:
                              "#C88719",
                          }}
                        >
                          {
                            selectedChild.total_late ||
                            0
                          }
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
              >
                <Box
                  sx={{
                    p: 2.5,
                    height: "100%",
                    borderRadius: 3,
                    background:
                      darkMode
                        ? "linear-gradient(145deg,#1f2937,#111827)"
                        : "#ffffff",
                    border:
                      `1px solid ${theme.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: 17,
                      color:
                        theme.text,
                      mb: 2,
                    }}
                  >
                    Fees Information
                  </Typography>

                  <Box
                    sx={{
                      display:
                        "flex",
                      justifyContent:
                        "space-between",
                      gap: 2,
                      p: 1.4,
                      mb: 1,
                      borderRadius: 2,
                      background:
                        darkMode
                          ? "rgba(255,255,255,.04)"
                          : "#f8fafc",
                    }}
                  >
                    <Typography
                      sx={{
                        color:
                          theme.secondary,
                        fontWeight: 600,
                      }}
                    >
                      Total Fee
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 900,
                        color:
                          theme.text,
                      }}
                    >
                      $
                      {Number(
                        selectedChild.total_fee ||
                          0
                      ).toLocaleString(
                        "en-US"
                      )}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display:
                        "flex",
                      justifyContent:
                        "space-between",
                      gap: 2,
                      p: 1.4,
                      mb: 1,
                      borderRadius: 2,
                      background:
                        darkMode
                          ? "rgba(34,197,94,.08)"
                          : "#f0fdf4",
                    }}
                  >
                    <Typography
                      sx={{
                        color:
                          theme.secondary,
                        fontWeight: 600,
                      }}
                    >
                      Amount Paid
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 900,
                        color:
                          "#16a34a",
                      }}
                    >
                      $
                      {Number(
                        selectedChild.amount_paid ||
                          0
                      ).toLocaleString(
                        "en-US"
                      )}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display:
                        "flex",
                      justifyContent:
                        "space-between",
                      gap: 2,
                      p: 1.4,
                      borderRadius: 2,
                      background:
                        darkMode
                          ? "rgba(239,68,68,.08)"
                          : "#fef2f2",
                    }}
                  >
                    <Typography
                      sx={{
                        color:
                          theme.secondary,
                        fontWeight: 600,
                      }}
                    >
                      Balance
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 900,
                        color:
                          "#ef4444",
                      }}
                    >
                      $
                      {Number(
                        selectedChild.balance_fee ||
                          0
                      ).toLocaleString(
                        "en-US"
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
              >
                <Box
                  sx={{
                    p: 2.5,
                    borderRadius: 3,
                    background:
                      darkMode
                        ? "linear-gradient(145deg,#1f2937,#111827)"
                        : "#ffffff",
                    border:
                      `1px solid ${theme.border}`,
                  }}
                >
                  <Box
                    sx={{
                      display:
                        "flex",
                      justifyContent:
                        "space-between",
                      alignItems:
                        "center",
                      mb: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 900,
                        color:
                          theme.text,
                      }}
                    >
                      Complaints
                    </Typography>

                    <Box
                      sx={{
                        px: 1.3,
                        py: 0.4,
                        borderRadius: 20,
                        fontSize: 11,
                        fontWeight: 800,
                        background:
                          "#fff7ed",
                        color:
                          "#c2410c",
                      }}
                    >
                      {
                        selectedChild
                          .complaints
                          ?.length ||
                        0
                      }
                    </Box>
                  </Box>

                  {selectedChild.complaints &&
                  selectedChild.complaints
                    .length > 0 ? (
                    selectedChild.complaints.map(
                      (item) => (
                        <Box
                          key={item.id}
                          sx={{
                            p: 1.8,
                            mb: 1.2,
                            borderRadius: 2,
                            background:
                              darkMode
                                ? "rgba(255,255,255,.04)"
                                : "#f8fafc",
                            border:
                              `1px solid ${theme.border}`,
                            borderLeft:
                              "4px solid #C88719",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 800,
                              fontSize: 14,
                              color:
                                theme.text,
                              mb: 0.4,
                            }}
                          >
                            {item.title}
                          </Typography>

                          <Typography
                            sx={{
                              color:
                                theme.secondary,
                              fontSize: 13,
                              lineHeight: 1.6,
                            }}
                          >
                            {
                              item.description
                            }
                          </Typography>
                        </Box>
                      )
                    )
                  ) : (
                    <Box
                      sx={{
                        py: 3,
                        textAlign:
                          "center",
                        borderRadius: 2,
                        background:
                          darkMode
                            ? "rgba(255,255,255,.03)"
                            : "#f8fafc",
                      }}
                    >
                      <Typography
                        sx={{
                          color:
                            theme.secondary,
                          fontSize: 13,
                        }}
                      >
                        No complaints found
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Box>
      );
    };

  /*
   * ============================================================
   * MAIN PAGE RENDER
   * ============================================================
   */

  const renderPage =
    () => {
      if (selectedUser) {
        return (
          <div
            style={{
              width: "100%",
              padding: 4,
            }}
          >
            <div
              style={{
                padding: 20,
                borderRadius: 10,
                border:
                  `1px solid ${theme.border}`,
                background:
                  theme.card,
                color:
                  theme.text,
              }}
            >
              User details are not available
              from the student portal.
            </div>
          </div>
        );
      }

      if (
        activePage.startsWith(
          "child_"
        )
      ) {
        return renderStudentPage();
      }

      return renderNormalPage();
    };

  /*
   * ============================================================
   * NAVIGATION ITEM
   * ============================================================
   */

  const renderNavigationItem =
    (item) => {
      const active =
        activePage === item.key &&
        !selectedUser;

      return (
        <Tooltip
          key={item.key}
          title={
            collapsed
              ? item.label
              : ""
          }
          placement="right"
        >
          <button
            type="button"
            className={[
              "student-nav-item",
              active
                ? "active"
                : "",
              collapsed
                ? "student-collapsed-item"
                : "",
            ].join(" ")}
            onClick={() =>
              handleNavigation(
                item.key
              )
            }
            disabled={
              isNavigating
            }
            aria-current={
              active
                ? "page"
                : undefined
            }
          >
            <span className="student-nav-icon">
              {item.icon}
            </span>

            <span className="student-nav-label">
              {item.label}
            </span>

            <span className="student-nav-chevron">
              <span
                style={{
                  display:
                    "flex",
                  fontSize: 9,
                }}
              >
                ›
              </span>
            </span>
          </button>
        </Tooltip>
      );
    };

  /*
   * ============================================================
   * SIDEBAR
   * ============================================================
   */

  const sidebar = (
    <div className="student-sidebar-shell">
      <div className="student-sidebar-content">
        <div
          style={{
            height: "100%",
            minHeight: "100vh",
            display: "flex",
            flexDirection:
              "column",
            background:
              "transparent",
          }}
        >
          {/* LOGO */}

          <div
            style={{
              height: 72,
              minHeight: 72,
              display:
                "flex",
              alignItems:
                "center",
              justifyContent:
                collapsed
                  ? "center"
                  : "flex-start",
              gap: 11,
              padding:
                collapsed
                  ? "0 10px"
                  : "0 18px",
              borderBottom:
                "1px solid rgba(143,168,255,.11)",
            }}
          >
            <div
              style={{
                width: 38,
                height: 38,
                minWidth: 38,
                borderRadius: 8,
                padding: 2,
                background:
                  "#FFFFFF",
                display:
                  "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
                overflow:
                  "hidden",
                border:
                  "1px solid rgba(143,168,255,.30)",
                boxShadow:
                  "0 4px 14px rgba(0,0,0,.25)",
              }}
            >
              <img
                src={logo}
                alt="IGNITE logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit:
                    "cover",
                  borderRadius: 6,
                  display:
                    "block",
                }}
              />
            </div>

            {!collapsed && (
              <div
                style={{
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    color:
                      "#F4F7FB",
                    fontSize: 13,
                    fontWeight: 800,
                    whiteSpace:
                      "nowrap",
                    overflow:
                      "hidden",
                    textOverflow:
                      "ellipsis",
                    letterSpacing:
                      ".15px",
                  }}
                >
                  IGNITE
                </div>

                <div
                  style={{
                    marginTop: 3,
                    color:
                      "#8FA8FF",
                    fontSize: 8,
                    fontWeight: 800,
                    letterSpacing:
                      1.05,
                    whiteSpace:
                      "nowrap",
                    overflow:
                      "hidden",
                    textOverflow:
                      "ellipsis",
                  }}
                >
                  STUDENT PORTAL
                </div>
              </div>
            )}
          </div>

          {/* SEARCH */}

          {!collapsed && (
            <div
              className="student-sidebar-search"
              style={{
                padding:
                  "13px 12px 6px",
                flexShrink: 0,
              }}
            >
              <Input
                allowClear
                value={menuSearch}
                onChange={(event) =>
                  setMenuSearch(
                    event.target.value
                  )
                }
                placeholder="Find a module or student..."
                prefix={
                  <SearchOutlined
                    style={{
                      color:
                        COLORS.sidebarBright,
                    }}
                  />
                }
              />
            </div>
          )}

          {/* NAVIGATION */}

          <div
            className="student-sidebar-scroll"
            style={{
              flex: 1,
              minHeight: 0,
              overflowY:
                "auto",
              overflowX:
                "hidden",
              paddingBottom: 20,
            }}
          >
            {/* STUDENT PORTAL */}

            {filteredBaseItems.length >
              0 && (
              <div>
                {!collapsed ? (
                  <div className="student-section-title">
                    STUDENT PORTAL
                  </div>
                ) : (
                  <div
                    style={{
                      height: 12,
                    }}
                  />
                )}

                {filteredBaseItems.map(
                  renderNavigationItem
                )}
              </div>
            )}

            {/* MY STUDENTS */}

            {(
              filteredChildItems.length >
                0 ||
              (!menuSearch &&
                loadingChildren)
            ) && (
              <>
                {!collapsed ? (
                  <div className="student-section-title">
                    BIO DATA

                    {!loadingChildren &&
                      children.length >
                        0 && (
                        <span
                          className="student-child-count"
                          style={{
                            float:
                              "right",
                            marginTop:
                              -5,
                          }}
                        >
                          {
                            children.length
                          }
                        </span>
                      )}
                  </div>
                ) : (
                  <div
                    style={{
                      height: 12,
                    }}
                  />
                )}

                {loadingChildren ? (
                  <div
                    className="student-child-empty"
                  >
                    Loading students...
                  </div>
                ) : filteredChildItems.length >
                  0 ? (
                  filteredChildItems.map(
                    renderNavigationItem
                  )
                ) : !menuSearch ? (
                  <div
                    className="student-child-empty"
                  >
                    No linked students found.
                  </div>
                ) : null}
              </>
            )}

            {/* NO SEARCH RESULT */}

            {filteredBaseItems.length ===
              0 &&
              filteredChildItems.length ===
                0 &&
              !loadingChildren && (
                <div
                  style={{
                    padding:
                      "35px 20px",
                    textAlign:
                      "center",
                    color:
                      "#8190A6",
                    fontSize: 11,
                  }}
                >
                  No module or student found
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={
        darkMode
          ? "student-dark"
          : ""
      }
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        overflow:
          "hidden",
        background:
          theme.background,
      }}
    >
      <Layout
        style={{
          height: "100vh",
          minHeight:
            "100vh",
          background:
            theme.background,
        }}
      >
        {/* DESKTOP SIDEBAR */}

        {!isMobile && (
          <Sider
            width={292}
            collapsedWidth={78}
            collapsed={
              collapsed
            }
            trigger={null}
            style={{
              position:
                "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              height:
                "100vh",
              zIndex: 100,
              overflow:
                "hidden",
              background:
                COLORS.sidebar,
            }}
          >
            {sidebar}
          </Sider>
        )}

        {/* MOBILE SIDEBAR */}

        {isMobile && (
          <Drawer
            open={
              drawerOpen
            }
            placement="left"
            width={310}
            closable={false}
            onClose={() =>
              setDrawerOpen(
                false
              )
            }
            styles={{
              body: {
                padding: 0,
                background:
                  COLORS.sidebar,
              },
            }}
          >
            <div
              style={{
                position:
                  "absolute",
                top: 13,
                right: 13,
                zIndex: 20,
              }}
            >
              <Button
                type="text"
                icon={
                  <CloseOutlined />
                }
                onClick={() =>
                  setDrawerOpen(
                    false
                  )
                }
                style={{
                  width: 34,
                  height: 34,
                  color:
                    "#DCE5F2",
                  background:
                    "rgba(143,168,255,.10)",
                  border:
                    "1px solid rgba(143,168,255,.15)",
                  borderRadius: 8,
                  display:
                    "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "center",
                }}
              />
            </div>

            {sidebar}
          </Drawer>
        )}

        <Layout
          style={{
            marginLeft:
              isMobile
                ? 0
                : collapsed
                ? 78
                : 292,

            height: "100vh",
            minHeight:
              "100vh",

            background:
              theme.background,

            transition:
              "margin-left 180ms ease",
          }}
        >
          {/* HEADER */}

          <Header
            style={{
              height: 68,
              minHeight: 68,
              flexShrink: 0,
              padding:
                isMobile
                  ? "0 9px"
                  : "0 16px",
              display:
                "flex",
              alignItems:
                "center",
              gap:
                isMobile
                  ? 6
                  : 10,
              background:
                theme.header,
              borderBottom:
                `1px solid ${theme.border}`,
              position:
                "relative",
              zIndex: 30,
            }}
          >
            {isNavigating && (
              <>
                <div className="student-navigation-progress" />

                <div className="student-loading-label">
                  Opening{" "}
                  {menuLookup[
                    pendingPage
                  ]?.label ||
                    selectedChild?.full_name ||
                    "module"}
                </div>
              </>
            )}

            {/* MENU BUTTON */}

            <Button
              type="text"
              className="student-menu-button"
              icon={
                isMobile ? (
                  <MenuUnfoldOutlined />
                ) : collapsed ? (
                  <MenuUnfoldOutlined />
                ) : (
                  <MenuFoldOutlined />
                )
              }
              onClick={() => {
                if (isMobile) {
                  setDrawerOpen(
                    true
                  );
                } else {
                  setCollapsed(
                    (value) =>
                      !value
                  );
                }
              }}
            />

            {/* USER SEARCH */}

            <div
              className="student-search-box"
              style={{
                flex: 1,
                minWidth: 0,
                maxWidth:
                  isMobile
                    ? 270
                    : 450,
              }}
            >
              <UserSearchBox
                theme={theme}
                setSelectedUser={
                  handleUserSelection
                }
                setActiveComponent={
                  setActivePage
                }
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 0,
              }}
            />

            {/* TASKS */}

            <Tooltip title="Tasks">
              <button
                type="button"
                className="student-header-action"
                onClick={() =>
                  setTodoOpen(
                    true
                  )
                }
              >
                <CheckSquareOutlined />
              </button>
            </Tooltip>

            <PostTodoList
              open={todoOpen}
              setOpen={
                setTodoOpen
              }
            />

            {/* DARK MODE */}

            <Darkmode
              darkMode={
                darkMode
              }
              setDarkMode={
                setDarkMode
              }
            />

            {/* NOTIFICATIONS */}

            {!isMobile && (
              <>
                <NotificationIcon
                  theme={theme}
                />

                <Notice />
              </>
            )}

            {/* PROFILE */}

            <Tooltip title="Profile">
              <div className="student-profile-container">
                <div className="student-profile-avatar">
                  <ProfileImage
                    theme={theme}
                    header
                  />
                </div>
              </div>
            </Tooltip>

            {/* LOGOUT */}

            {!isMobile && (
              <Tooltip title="Logout">
                <button
                  type="button"
                  className="student-header-action"
                  onClick={
                    handleLogout
                  }
                  disabled={
                    loadingLogout
                  }
                  style={{
                    color:
                      loadingLogout
                        ? "#8793A5"
                        : "#C44545",
                  }}
                >
                  <LogoutOutlined />
                </button>
              </Tooltip>
            )}
          </Header>

          {/* CONTENT */}

          <Content
            style={{
              background:
                theme.background,

              padding:
                isMobile
                  ? "9px 8px 12px"
                  : "14px 16px 18px",

              minHeight: 0,

              overflowY:
                "auto",

              overflowX:
                "hidden",
            }}
          >
            {/* PAGE HEADING */}

            <div className="student-page-heading">
              <div className="student-page-heading-left">
                <span className="student-page-heading-line" />

                <span className="student-page-heading-title">
                  {activeTitle}
                </span>
              </div>

              {!isMobile && (
                <span className="student-page-heading-meta">
                  IGNITE • STUDENT PORTAL - Design By: Polu
                </span>
              )}
            </div>

            {/* WORKSPACE */}

            <motion.div
              key={
                selectedUser
                  ? "user-details"
                  : activePage
              }
              initial={{
                opacity: 0,
                y: 6,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.2,
                ease:
                  "easeOut",
              }}
              className={
                darkMode
                  ? "student-workspace student-workspace-dark"
                  : "student-workspace"
              }
              style={{
                padding:
                  isMobile
                    ? 9
                    : 15,
              }}
            >
              {renderPage()}
            </motion.div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default StudentDashboard;